<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="recordId"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins:[TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar:{
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => {
            this.$emit("submit");
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: "seq",
          width: 50,
          fixed: "left",
          align: "center",
          type: "seq",
        },
        {
          field: "departmentName",
          minWidth: 250,
          title: this.$l("table_label_department_name") || "部门名称",
          align: "left",
          headAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
        {
          field: "prjQty",
          width: 200,
          title: this.$l("table_label_number_of_projects") || "创建项目数量",
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
        {
          field: "prjInProcessQty",
          width: 200,
          title: this.$l("table_label_number_of_progress") || "进行中数量",
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
        {
          field: "prjAcomplishedQty",
          width: 200,
          title:
            this.$l("table_label_number_of_completed_on_time") ||
            "按时完成数量",
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
        {
          field: "prjDelayQty",
          width: 200,
          title:
            this.$l("table_label_number_of_completed_overtime") ||
            "超时完成数量(含进行中)",
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
        {
          field: "prjTerminationQty",
          width: 200,
          title: this.$l("table_label_number_of_termination") || "终止取消数量",
          align: "left",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
        },
      ],
    };
  },
  methods: {},
};
</script>
